export const invitationExpireDays = 30;
